import { YYYYMMDD } from 'helpers/dateHelper';
import moment from 'moment';
import {
  GET_WORK_SHIFT_DAY_TYPES_ERROR,
  GET_WORK_SHIFT_DAY_TYPES_PENDING,
  GET_WORK_SHIFT_DAY_TYPES_SUCCESS,
  GET_WORK_SHIFT_ERROR,
  GET_WORK_SHIFT_PENDING,
  GET_WORK_SHIFT_SUCCESS,
  SET_WORK_SHIFT,
  SET_WORK_SHIFT_DAY_TYPES,
} from './constant';

const INIT_STATE = {
  isGetWorkShiftDayTypesPending: false,
  dayTypes: [],
  workshifts: [],
};

const filterCurrentDayEvent = (data) => {
  const currentDayEvent =
    (data &&
      data
        .filter(
          (shift) =>
            moment(shift.startDate).format(YYYYMMDD) ===
            moment().format(YYYYMMDD)
        )
        .map((obj) => {
          return {
            allDay: true,
            end: obj.startDate,
            start: obj.endDate,
            title: obj.code,
            workHour: obj.workHour,
          };
        })[0]) ||
    null;

  return currentDayEvent;
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case GET_WORK_SHIFT_DAY_TYPES_PENDING: {
      return {
        ...localState,
        isGetWorkShiftDayTypesPending: true,
      };
    }
    case GET_WORK_SHIFT_DAY_TYPES_SUCCESS: {
      return {
        ...localState,
        isGetWorkShiftDayTypesPending: false,
      };
    }
    case GET_WORK_SHIFT_DAY_TYPES_ERROR: {
      return {
        ...localState,
        isGetWorkShiftDayTypesPending: false,
      };
    }
    case SET_WORK_SHIFT_DAY_TYPES: {
      return {
        ...localState,
        dayTypes: action.payload,
      };
    }
    case GET_WORK_SHIFT_PENDING: {
      return {
        ...localState,
        isGetWorkShiftPending: true,
      };
    }
    case GET_WORK_SHIFT_SUCCESS: {
      return {
        ...localState,
        isGetWorkShiftPending: false,
      };
    }
    case GET_WORK_SHIFT_ERROR: {
      return {
        ...localState,
        isGetWorkShiftPending: false,
      };
    }
    case SET_WORK_SHIFT: {
      return {
        ...localState,
        workshifts: action.payload,
        todayWorkShift: filterCurrentDayEvent(action.payload),
      };
    }
    default:
      return { ...localState };
  }
};
